<template>
  <b-card>
    <modelo-list
      :carregar="carregar"
      :novo="novo"
      :editar="editar"
      :remover="remover"
      :colunas="colunasListagem"
      :info="info"
      :mensagem-remocao="mensagemRemocao"
      :filtros="filtros"
      filtrar-por-ativo
      @removerItem="remover($event)"
      @entidades-vinculadas="getEmpresas"
    >
      <template slot="corpo-info-adicional">
        <hr style="border-top: 1px solid #a3a4a66b !important; margin: 0.5rem 0">
        <b-row class="mb-1">
          <b-col
            cols="12"
            style="text-align:center"
          >
            <span>Empresas Vinculadas</span>
          </b-col>
        </b-row>
        <div
          v-for="(empresa,i) in empresasPorModelo"
          :key="i"
        >
          <b-row>
            <b-col cols="12">
              <span
                class="empresa-vinculada"
                @click="acessaEmpresa(empresa.id)"
              >{{ `${empresa.razaoSocial} - ${empresa.cadastroFederal}` }}</span>
            </b-col>
          </b-row>
        </div>
      </template>
    </modelo-list>
  </b-card>
</template>

<style lang="scss">
.empresa-vinculada:hover{
  text-decoration: underline;
  cursor: pointer;
}
</style>

<script>
import api from '@/app-modulo/documento/modelo/shared/services/api'
import apiEmpresa from '@/app-modulo/comuns/empresa/shared/services/api'

export default {
  name: 'ModeloVisualizacao',
  components: {
    ModeloList: () => import('@/shared/components/visualizacao-base/VisualizacaoBase.vue'),
  },
  data() {
    return {
      colunasListagem: [
        {
          label: 'Descrição', field: 'descricao', type: 'personalizada', showActive: true, editable: true,
        },
        { label: 'Tipo', field: 'tipoModelo' },
        { label: 'Documentos selecionados', field: 'documentosSelecionados' },
      ],
      filtros: [{ colunas: ['Descricao', 'TipoModelo', 'DocumentosSelecionados'], valor: null }],
      info: [
        { label: 'Data de cadastro: ', campo: 'dataCadastro' },
        { label: 'Cadastrado por: ', campo: 'usuCadastro' },
        { label: 'Data de alteração: ', campo: 'dataAlteracao' },
        { label: 'Alterado por: ', campo: 'usuAlteracao' },
      ],
      empresas: null,
      mensagemRemocao: 'Deseja remover o modelo (e seus documentos) de todas as empresas vinculadas? Digite sua senha para confirmar.',
      empresasPorModelo: [],
    }
  },
  created() {
  },
  methods: {
    carregar(page, pageSize, filtros) {
      return api.getModelos(page, pageSize, filtros)
    },
    novo() {
      this.$router.push({ name: 'novo-modelo' })
    },
    editar(value) {
      this.$router.push({ name: 'editar-modelo', params: { id: value.id } })
    },
    remover(itens) {
      const itensInner = itens
      return new Promise(resolve => {
        // eslint-disable-next-line no-plusplus
        for (let i = 0; i < itensInner.length; i++) {
          const item = itensInner[i]
          api.deleteModelo(item.id)
            .then(() => {
              // tenporario
              if (i === itensInner.length - 1) {
                resolve()
              }
            })
            .catch(err => {
              this.$handleError(err)
            })
        }
      })
    },
    getEmpresas(rowId) {
      apiEmpresa.getEmpresasPorModelo(rowId)
        .then(payload => {
          this.empresasPorModelo = payload.data
        })
    },
    acessaEmpresa(id) {
      this.$router.push(`/empresas/editar/${id}`)
    },
  },
}
</script>
